import axios from 'axios';

// 数据统计页
export function getSummary() {
  return axios.get('/analysis/console_summary');
}
